import {useEffect, useState} from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, EffectFade} from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";

import TileGrid from "./TileGrid";
import s from "./Hero.module.scss";
import RevSlider from "./RevSlider";

const Hero = () => {
    // const [slides, setSlides] = useState([]);
    // const [loading, setLoading] = useState(true);
    // useEffect(() => {
    //
    //     const fetchSlides = async () => {
    //         try {
    //             const res = await fetch(
    //                 `${process.env.REACT_APP_API_LOCAL_URL}top-slider`
    //             );
    //
    //             if (!res.ok) throw new Error("Failed to load slider");
    //
    //             const data = await res.json();
    //
    //             const formatted = data.map((item) => ({
    //                 id: item.id,
    //                 title: item.title,
    //                 subtitle: item.subtitle,
    //                 images: item.images.map((img) => img.image_url),
    //             }));
    //
    //             setSlides(formatted);
    //
    //             // 👉 FLATTEN ALL IMAGES
    //             const allImages = formatted.flatMap((s) => s.images);
    //
    //             await preloadImages(allImages);
    //
    //             setLoading(false);
    //         } catch (err) {
    //             console.error(err);
    //             setLoading(false);
    //         }
    //     };
    //
    //     fetchSlides();
    // }, []);
    // const preloadImages = (images) => {
    //     return Promise.all(
    //         images.map((src) => {
    //             return new Promise((resolve) => {
    //                 const img = new Image();
    //                 img.src = src;
    //
    //                 img.onload = () => resolve(src);
    //                 img.onerror = () => resolve(src); // don't block slider if one fails
    //             });
    //         })
    //     );
    // };
    // if (!slides.length) return null;
    // if (loading || !slides.length) {
    //     return (
    //         <div className={s.loaderWrapper}>
    //             <img
    //                 src="/loader.gif"
    //                 alt="Loading..."
    //                 className={s.loaderGif}
    //             />
    //         </div>
    //     );
    // }
    return (
        // <div className={s.heroWrapper}>
        //     <Swiper
        //         modules={[Autoplay, EffectFade]}
        //         effect="fade"
        //         autoplay={{
        //             delay: 5000,
        //             disableOnInteraction: false,
        //         }}
        //         loop={true}
        //         speed={800}
        //         className={s.swiper}
        //         preloadImages={true}
        //         lazy={true}
        //     >
        //         {slides.map((slide) => (
        //             <SwiperSlide key={slide.id}>
        //                 <div className={s.slide}>
        //                     <TileGrid images={slide.images}/>
        //                     <div className={s.overlay}/>
        //
        //                     <div className={s.content}>
        //                         <h1>{slide.title}</h1>
        //                         <p>{slide.subtitle}</p>
        //                     </div>
        //                 </div>
        //             </SwiperSlide>
        //         ))}
        //     </Swiper>
        // </div>
        <div className={s.heroWrapper}> <RevSlider /> </div>
    );
};

export default Hero;